module.exports = __webpack_public_path__ + "img/introduce_content_3_ug.312f05c8.png";